const MapWidget = function (data) {
  var rootUrl = "https://api-stage.mapcard.pro";

  var widget = this;
  var wrapper, iframe, back, layout, loader;

  widget.Token = data.Token;
  widget.Amount = data.Amount;
  widget.Currency = data.Currency;
  widget.Receipt = data.Receipt ? data.Receipt : false;
  widget.Email = data.Email ? data.Email : "";
  widget.OrderID = data.OrderID
    ? data.OrderID
    : "map_widget_" + generateOrderID(10);
  widget.ProductName = data.ProductName ? encodeURI(data.ProductName) : "";
  widget.CustomParams = data.CustomParams ? data.CustomParams : [];
  if (data.AutoClose) widget.AutoClose = data.AutoClose;
  if (data.ShowGoods) widget.ShowGoods = data.ShowGoods;
  if (data.Goods) widget.Goods = data.Goods;

  function initializeWidget(params, callback, errorCallback) {
    var data = {
      token: params.Token,
      merchant_order_id: params.OrderID.toString(),
      amount: params.Amount,
      custom_params: params.CustomParams,
    };

    if (params.Email && params.Email != "")
      data.custom_params.push({
        key: "Email",
        value: params.Email,
      });

    if (params.ProductName && params.ProductName != "") {
      data.custom_params.push({
        key: "ProductName",
        value: decodeURI(params.ProductName),
      });
    }

    if (params.Goods) data.goods = params.Goods;

    fetch(rootUrl + "/PaymentInit", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(data),
    })
      .then((response) => response.json())
      .then((resp) => {
        if (resp.success) {
          widget.SessionID = resp.session_id;
          setTimeout(function () {
            callback();
          }, 500);
        } else {
          console.log(new Error(resp.ErrCode + ":" + resp.ErrMessage));
          errorCallback();
        }
      })
      .catch((err) => {
        console.log(err);
        errorCallback();
      });
  }

  function loadWidget() {
    loader.style.display = "none";
    back.style.background = "rgb(0,0,0)";

    var data = widget;
    if (data != "undefined" && data != null) {
      var src = rootUrl + "/Payment?";
      for (var prop in data) {
        var value = data[prop];
        if (prop == "Goods") {
          for (var i = 0; i < value.length; i++) {
            src =
              src +
              prop +
              "=" +
              encodeURIComponent(value[i]["name"]) +
              "goods-price-delim" +
              encodeURIComponent(value[i]["price"]) +
              "&";
          }
        } else {
          src = src + prop + "=" + value + "&";
        }
      }
      src = src.substring(0, src.length - 1);
    }

    if (iframe) {
      iframe.src = src;
    }
  }

  function closeWidget() {
    var el = document.getElementById("map-widget-wrapper");
    el.parentElement.removeChild(el);
  }

  function renderLayout() {
    wrapper = document.createElement("div");
    wrapper.setAttribute("id", "map-widget-wrapper");
    wrapper.style.cssText =
      "z-index:9997;text-align:left;height:100%;width:100%;position:fixed;left:0px;top:0px;transition:opacity0.15sease0s;overflow:hidden;pointer-events:all;opacity:1;";

    back = document.createElement("div");
    back.setAttribute("id", "map-widget-background");
    back.style.cssText =
      "z-index:9998;background:rgb(255,255,255);opacity:0.75;position:fixed;left:0px;top:0px;bottom:0px;right:0px;border:0px;overflow:visible;transition:all .5s ease";

    layout = document.createElement("div");
    layout.setAttribute("id", "map-widget-layout");
    layout.style.cssText =
      "width:100%;height:100%;border:none;z-index:9999;text-align:center";

    loader = document.createElement("div");
    loader.setAttribute("id", "map-widget-loader");
    loader.style.cssText =
      "z-index:9998;width:100%;position:fixed;bottom:45%;height:120px;background-position:50%;background-repeat:no-repeat;background-size:120px;background-image:url(https://static-stage.mapcard.pro/static/widget/map-loader.gif)";
    layout.appendChild(loader);

    iframe = document.createElement("iframe");
    iframe.setAttribute("id", "map-widget-iframe");
    iframe.setAttribute("frameborder", "0");
    iframe.setAttribute('allowpaymentrequest', '');
    iframe.setAttribute("scrolling", "no");
    iframe.style.cssText =
      "position:fixed;width:100%;height:100%;left:0;right:0;top:0;left:0;border:none;z-index:9999;";
    layout.appendChild(iframe);

    wrapper.appendChild(back);
    wrapper.appendChild(layout);
    document.body.appendChild(wrapper);
  }

  renderLayout();
  initializeWidget(widget, loadWidget, closeWidget);
};

export default MapWidget;

function generateOrderID(length) {
  var text = "";
  var possible =
    "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
  for (var i = 0; i < length; i++)
    text += possible.charAt(Math.floor(Math.random() * possible.length));
  return text;
}

window.addEventListener("message", function (e) {
  if (
    e.origin == "https://api-stage.mapcard.pro" ||
    e.origin == "https://api-stage.mapisacard.com" ||
    e.origin == "https://api-stage-proxy.mapcard.pro" ||
    e.origin == "https://api-stage-proxy.mapisacard.com"
  ) {
    if (e.data.trigger == "closeFrame") {
      var el = document.getElementById("map-widget-wrapper");
      el.parentElement.removeChild(el);
    }
  } else {
    return;
  }
});
